import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3337/',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*'
    }
  })
}